'use client';

import React from 'react';

import { TasticProps } from 'frontastic/tastics/types';
import  {RenovationGuideProps} from 'components/commercetools-ui/organisms/renovation-guide';
import RenovationPage from 'components/commercetools-ui/organisms/renovation-guide';


const RenovationPageTastic  = ({ data }: TasticProps<RenovationGuideProps>) => {


  return <RenovationPage data={data?.data?.dataSource} image={undefined} />;
};

export default RenovationPageTastic;